<div class="container-fluid">
  <div class="form-horizontal">
    <h3>
      {{ 'events.registration.wizard.attendees.title' | translate | titlecase }}
      <span class="hidden-lg">
        <button app-add-button
          [disabled]="!canAddNewAttendee || _loading"
          [label]="'events.registration.wizard.attendees.new-attendee-button-label' | translate | titlecase"
          (onClick)="addNewAttendee()"
        >
        </button>
      </span>
    </h3>

    <p *ngIf="_loading"><wl-busy [show]="_loading"></wl-busy></p>
    <p *ngIf="!_loading && !registration.Attendees.length">{{ 'events.registration.wizard.attendees.no-attendees-added' | translate }}</p>

    <p [hidden]="canAddNewAttendee || registration.Attendees.length <= 0">
      {{ 'events.registration.wizard.attendees.all-attendees-have-been-added-label' | translate | titlecase }}
    </p>
    <div
      class="wc-event-reg-wiz-attendee highlight-box has-violator-tag wc-event-reg-wiz-attendee-{{ i }}"
      *ngFor="let attendee of registration.Attendees; let first = first; let last = last; let i = index"
    >
      <div class="violator-tag bg-default">
        <span [hidden]="!attendee.FName && !attendee.LName">{{ attendee.FName }} {{ attendee.LName }}</span>
        <span [hidden]="attendee.FName || attendee.LName"
          >{{ 'events.registration.wizard.attendees.attendee-tab-prefix' | translate | titlecase }}{{ i + 1 }}</span
        >
      </div>
      <wl-registration-wizard-attendee
        [attendee]="attendee"
        [eventItems]="attendee.Items"
        [customFields]="allPossibleCustomFields"
        [searchAllProfiles]="searchAllProfiles"
        [editingRegistration]="registration?.IsEdit"
        [registrationProfileId]="registrationProfile?.ProfileId"
        [event]="event"
        [isOrg]="registrationProfile?.OrgInd"
        (responseChange)="onResponseChange($event, attendee)"
        (onItemSelectionChanged)="attendeeItemSelectionChanged($event, attendee)"
        (remove)="removeAttendee(attendee)"
      >
      </wl-registration-wizard-attendee>
    </div>
  </div>
</div>
